'use client'

import { useContext } from 'react'

import { Box, Text } from '@doist/marketist'

import { useTranslation } from 'app/i18n/client'
import { GetStartedButtonSimple } from 'components/Get-Started-Button/Get-Started-Button'
import { useLocale } from 'next-intl'

import css from './button.module.css'

import { PricingContext } from '@/app/services/providers/contexts/pricing-context'

export function SignupButton() {
    const { model, currency } = useContext(PricingContext)
    const pricing = model[currency]

    const locale = useLocale()
    const { t: tPricing } = useTranslation(locale, 'pricing_v2_3')

    return (
        <Box className={css.buttonWithPricing}>
            <GetStartedButtonSimple size="xl" />
            <Text size="body-xs" weight="medium" className={css.onlightSecondary}>
                {tPricing('billing.then')} <sup>{pricing.shortName}</sup>
                {tPricing('billing.currencyPrice', {
                    currency: pricing.shortSymbol,
                    price: pricing['teams']['yearlyPerMonth'].toFixed(0),
                })}{' '}
                {tPricing('billing.perMember')} {tPricing('billing.billedYearly')}
            </Text>
        </Box>
    )
}
